import { render, staticRenderFns } from "./TaskKindList.vue?vue&type=template&id=25767bb5"
import script from "./TaskKindList.vue?vue&type=script&lang=js"
export * from "./TaskKindList.vue?vue&type=script&lang=js"
import style0 from "./TaskKindList.vue?vue&type=style&index=0&id=25767bb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports